import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { EventService } from '../../../services/event.service';
import { AnnualProgramService } from '../../../services/annual-program.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import * as moment from 'moment';
import StoreEventStation from '../../../interfaces/StoreEventStation';
import {Observable} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';

interface Event {
  id: string;
  name: string;
  custom_name?: string;
  event: Array<string>;
  custom_event?: string;
  element: string;
  custom_element?: string;
  activity: string;
  custom_activity?: string;
  frequency: string;
  description: string;
  custom_frequency?: {
    number: string;
    frequency: string;
  };
  date: any;
}
@Component({
  selector: 'ngx-add-edit-event-annual-program',
  templateUrl: './add-edit-event-annual-program.component.html',
  styleUrls: ['./add-edit-event-annual-program.component.scss']
})
export class AddEditEventAnnualProgramComponent implements OnInit {
  @Input() edit = false;
  @Input() addDefaultEvent = false;
  @Input() event?: any;
  @Input() defaultEvent?: any;
  @Input() stationId: string;
  showCustomEvent = false;
  loading = false;
  catalog: any = {
    activities: [],
    elements: [],
    frequencies: [],
    names: [],
    types: []
  }
  formData: Event = {
    id: '0',
    name: '',
    event: [],
    element: '',
    activity: '',
    frequency: '',
    description: '',
    date: new Date(),
    custom_frequency: {
      number: '',
      frequency: '',
    },
  };

  constructor(
    protected ref: NbDialogRef<AddEditEventAnnualProgramComponent>,
    private annualProgramService: AnnualProgramService,
    private eventService: EventService,
  ) { }

  async ngOnInit() {
    await this.getCatalog();
    if (this.addDefaultEvent) {
      //console.log(this.defaultEvent)
      this.formData.activity = this.defaultEvent.activity;
      this.formData.description = this.defaultEvent.description;
      this.formData.element = this.defaultEvent.equipment;
      this.formData.name = this.defaultEvent.area;
      this.formData.frequency = this.defaultEvent.periodicity.charAt(0).toUpperCase() + this.defaultEvent.periodicity.slice(1);
      this.formData.event = this.defaultEvent.event;
      return;
    }
    if (this.event) {
      this.formData = this.event
      this.formData.event = this.event.type.split(',')
      //console.error(this.formData)
    }
  }

  async getCatalog () {
    this.loading = true;
    const [error, response] = await this.annualProgramService.getAnnualProgramNewCatalog();
    this.loading = false
    if (error) return this.alert('Error', 'error', 'Hubo un error al consultar el catalogo');
    this.catalog = response.data
    this.catalog.types = this.catalog.types.map(type => type.toLowerCase())
    //console.error(this.catalog)
  }

  prepareData () {
    this.catalog.types = this.catalog.types.map(catalog => { return { label: catalog, selected: false } })
  }

  dismiss() {
    this.ref.close(false);
  }

  async create() {
    this.loading = true;
    const data: StoreEventStation = {
      name: (this.formData.name !== 'custom') ? this.formData.name : this.formData.custom_name,
      element: (this.formData.element !== 'custom') ? this.formData.element : this.formData.custom_element,
      activity: (this.formData.activity !== 'custom') ? this.formData.activity : this.formData.custom_activity,
      frequency: this.formData.frequency,
      description: this.formData.description,
      type: (this.formData.custom_event) ? this.formData.event.join(',') + this.formData.custom_event : this.formData.event.join(','),
      date: moment(this.formData.date).format('YYYY-MM-DD'),
      station_id: this.stationId,
      default_event: this.addDefaultEvent ? this.defaultEvent.id : false
    }
    if (this.formData.frequency === 'custom') data.custom_frequency = this.formData.custom_frequency;
    const [error, response] = await this.eventService.store(data);
    this.loading = false;
    if (error) {
      let html = ''
      if (error.error  && error.error.error) for (const message of error.error.error) html += `<span>${message}</span><br>`
      else html = error.message
      return this.alert('Error', 'error', '', html);
    }
    await this.alert('Éxito', 'success', 'Se creo el evento')
    this.ref.close(true);
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '', html: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
      html: html,
    });
  }

  async editEvent () {
    this.loading = true;
    const type = (this.formData.custom_event) ? this.formData.event.join(',') + this.formData.custom_event : this.formData.event.join(',')
    const [error] = await this.eventService.updateEvent(this.formData.id, { ...this.formData, type });
    this.loading = false;
    if (error) {
      let html = ''
      if (error.error  && error.error.error) for (const message of error.error.error) html += `<span>${message}</span><br>`
      else html = error.message
      return this.alert('Error', 'error', '', html);
    }
    await this.alert('Éxito', 'success', 'Se edito el evento')
    this.ref.close(true);
  }

  checkIfSelectCustom () {
    const findCustom = this.formData.event.find(event => event === 'custom');
    console.error(this.formData.event, findCustom);
    if (findCustom) return this.showCustomEvent = true;
    this.formData.custom_event = '';
    this.showCustomEvent = false;
  }

  searchElements = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.catalog['elements'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
  )

searchNames = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.catalog['names'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
  )

searchActivities = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.catalog['activities'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
  )

searchServices = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    map(term => this.catalog['types'].filter(element => element.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 20)),
  )

}
